module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"navTooltip\" class=\"row\">\r\n    <div class=\"col-md-4 prop-sublabel\">Tooltip</div>\r\n    <div class=\"col-md-8 nopadding\"><input type=\"text\" name=\"toolTip\" class=\"tooltipInput\" value=\"")
    ; __append(escapeFn(toolTip))
    ; __append("\" /> </div>\r\n</div>")
  }
  return __output;

}